import I18n from 'i18n-js';
import React from 'react';

import CollectionHeaderComponent from '../collection_header_component';
import CollectionHeader from '@reverbdotcom/commons/src/components/stores/collection_header';
import { CollectionHeaderStore } from '@reverbdotcom/commons/src/components/stores/collection_header_store';
import CollectionSEOContent from '../collection_seo_content';
import CSPMiniGridContainer from './csp_mini_grid_container';
import CSPSquareRow from './csp_square_row';
import RelatedArticlesManager from '../related_articles_manager';
import CSPStore from './csp_store';
import CurationModal from '../curation/modal';
import CollectionPageTitle from '../collection_page_title';
import { get } from 'lodash';
import CuratedSetRow from '../curated_set_row';
import MarketplaceLinkProps from '../marketplace_link_props';
import { Location } from 'history';

const RCSPStore = CSPStore as any;

interface Props {
  params: object;
  articleManagerParams?: object;
  stripBrandFromTitle?: boolean;
  marketplaceLinkProps?: MarketplaceLinkProps;
  withCuratedSets?: boolean;
  shouldShuffleCuratedSets?: boolean;
  changePageCb?: (page: any) => void;
  location: Location;
}

interface State {
  loaded?: boolean;
  collectionHeader: CollectionHeader;
}

class CSPGrid extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      loaded: RCSPStore.getState().loaded,
      collectionHeader: CollectionHeaderStore.getState().collectionHeader,
    };

    this.onCollectionHeaderStoreUpdated = this.onCollectionHeaderStoreUpdated.bind(this);
    this.onComparisonShoppingPageStoreUpdated
      = this.onComparisonShoppingPageStoreUpdated.bind(this);
  }

  componentDidMount() {
    CollectionHeaderStore.listen(this.onCollectionHeaderStoreUpdated);
    RCSPStore.listen(this.onComparisonShoppingPageStoreUpdated);
  }

  componentWillUnmount() {
    CollectionHeaderStore.unlisten(this.onCollectionHeaderStoreUpdated);
    RCSPStore.unlisten(this.onComparisonShoppingPageStoreUpdated);
  }

  onCollectionHeaderStoreUpdated() {
    const { collectionHeader } = CollectionHeaderStore.getState();
    this.setState({ collectionHeader });
  }

  onComparisonShoppingPageStoreUpdated() {
    this.setState({ loaded: RCSPStore.getState().loaded });
  }

  rowPages() {
    return RCSPStore.featuredPagesWithImages();
  }

  get heading() {
    return I18n.t(
      'discovery.comparisonShoppingPages.exploreTitle',
      { title: this.title },
    );
  }

  get title() {
    return get(this.state, 'collectionHeader.title') || '';
  }

  curatedSetRow() {
    if (!this.props.withCuratedSets) {
      return null;
    }

    return (
      <CuratedSetRow
        showHeading
        shouldShuffle={this.props.shouldShuffleCuratedSets}
        centeredTitle
      />
    );
  }

  render() {
    return (
      <div className="csp-grid">
        <CollectionPageTitle />
        <CollectionHeaderComponent
          headerLinkTarget={this.props.location.pathname}
          hideBanner
        />
        <CollectionSEOContent />
        <CSPSquareRow
          title={I18n.t('discovery.comparisonShoppingPages.featuredBrand')}
          pages={this.rowPages()}
          trackName="FeaturedCSPs"
          centeredTitle
          loaded={!!this.rowPages().length}
        />
        <CSPMiniGridContainer
          heading={this.heading}
          title={this.title}
          stripBrandFromTitle={this.props.stripBrandFromTitle}
          changePageCb={this.props.changePageCb}
        />
        {this.curatedSetRow()}
        <RelatedArticlesManager
          queryParams={this.props.articleManagerParams}
        />
        <CurationModal />
      </div>
    );
  }
}

export default CSPGrid;
